<template>
	<div>
		<mdb-row>
			<mdb-col md="4" sm="6">
				<div style="margin-bottom: 20px;">
					<div class="profile_picture">
						<img :src="profile_picture">
					</div>
				</div>
			</mdb-col>
		</mdb-row>
		<mdb-row>
			<mdb-col md="4" sm="6">
				<div class="form__group" style="margin-bottom: 10px;">

				    <label class="form__label">Nombre(s):</label>
					<input type="text" class="form__input" :value="this.firstName" disabled/>
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label class="form__label">Apellido Paterno:</label>
					<input type="text"   class="form__input" :value="this.lastName" disabled />
				</div>
			</mdb-col>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label class="form__label">Apellido Materno:</label>
					<input type="text" class="form__input" :value="this.motherLastName" disabled />
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="birthDate-spouse" class="form__label" style="transform: translateY(3px);">Fecha de nacimiento:</label>
					<input type="text" id="birthDate-spouse" class="form__input" :value="this.birthDate" disabled/>
					
				</div>
			</mdb-col>
		</mdb-row>



		<mdb-row>
			<mdb-col md="4" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="BirthEntity" class="form__label">Entidad de nacimiento:</label>
					<input type="text" id="BirthEntity" class="form__input" :value="this.birthPlace" disabled />
				</div>
			</mdb-col>
		</mdb-row>

		<!-- <mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="INESpouse" class="form__label">{{this.INE_PASSPORT}}</label>
					<input v-if="this.INE_PASSPORT_INF" type="text" id="UserINESpouse" class="form__input" :value="this.INE_PASSPORT_INF" disabled />
				</div>
			</mdb-col>
		</mdb-row> -->

		<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="CURP-spouse" class="form__label">CURP:</label>
					<input v-if="this.CURPInfo" type="text" id="UserCURP-spouse" class="form__input" :value="this.CURPInfo" disabled />
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="dia" class="form__label" style="transform: translateY(3px);">Acta de nacimiento:</label>
				</div>
			</mdb-col>
		</mdb-row>


		<Popup size="lg" ref="confirm" :title="tituloUrl"> 
			<div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
                    <iframe class="embed-responsive-item" :src="url" allowfullscreen></iframe>
			</div>
				<div class="accordion__button">
			<btn style="float: left;" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />
			</div>
			</Popup>
		
		<btn type="primary" @onClick="seeBirthPlace(BIRTH_CERTIFICATE_INF, 'Acta de nacimiento')" text="Ver Acta de nacimiento" icon="revisar" class="btn-acta-nacimiento" />
				<btn type="primary" @onClick="seeBirthPlace(urlCURP, 'CURP')" text="Ver CURP" icon="revisar" class="btn-acta-nacimiento" />
				<btn type="primary" @onClick="seeBirthPlace(urlIne, 'Identificación')" text="Ver Identificación" icon="revisar" class="btn-acta-nacimiento" />



		 
	</div>
</template>
<script>
	import btn from '../../core/Button';
	import Popup from "../../core/Popup";

	import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
	import { WebCam } from "vue-web-cam";
	import HelperMessage from "../../core/HelperMessage.vue";
	import Axios from "axios";
	import Swal from "sweetalert2";
	import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
	import Loader from "../../core/Loader";
	import VueCropper from "vue-cropperjs";
	import "cropperjs/dist/cropper.css";

	export default {
		name: "SpousePersonalData",
		components: {
			mdbContainer,
			mdbRow,
			mdbCol,
			mdbContainer,
			mdbRow,
			mdbCol,
			btn,
			HelperMessage,
			Loader,
			"vue-web-cam": WebCam,
			VueCropper,
			Popup
		},
		created(){
				this.userAllData = JSON.parse(localStorage.getItem("userAllData"))
				//console.log("userAllData Spouse", this.userAllData);
				
				if(this.userAllData.beneficiaries != null){
					
					let beneficiary = this.userAllData.beneficiaries;
					// 1.- DETECTAMOS EL TIPO DE  BENEFIACIARIO (SPOUSE)
					for (let i = 0; i < beneficiary.length; i++){
						if(beneficiary[i].beneficiaryType == "SPOUSE"){
							
							this.firstName = beneficiary[i].name;
							this.lastName = beneficiary[i].lastName;
							this.motherLastName = beneficiary[i].mothersLastName;
							this.birthDate = beneficiary[i].birthDate;
							this.birthPlace = beneficiary[i].birthPlace;

							for (let z = 0; z < beneficiary[i].documents.length; z++){
								let documents = beneficiary[i].documents[z];
								//console.log("documents", documents.documentType );
								
								if(documents.documentType == "CURP"){
									this.CURPInfo = documents.value;
									this.urlCURP = documents.publicURL
								}

								if(documents.documentType == "PASSPORT"){
									this.INE_PASSPORT = "Pasaporte:";
									this.INE_PASSPORT_INF = documents.value;
								}

								if(documents.documentType == "INE"){
									this.INE_PASSPORT = "INE:";
									this.INE_PASSPORT_INF = documents.value;
									this.urlIne = documents.publicURL
								}

								if(documents.documentType == "BIRTH_CERTIFICATE"){
									this.BIRTH_CERTIFICATE_INF = documents.publicURL;
									//console.log("documents.publicURL", documents.publicURL);
								}

								if(documents.documentType == "PROFILE_PICTURE"){
									this.profile_picture = documents.publicURL;
									//console.log("documents.publicURL", documents.publicURL);
								}

						
    			}
						}
						
				
					}

					

				}
				

				
		},
		data(){
			return {
				userAllData:"",
				infoIdIcon: 'info-default.svg',
				fileAvatar: "",
				camera: null,
				uploadIcon: "upload-document.svg",
				releaseIcon: "release-default.svg",
				approvedIcon: "approved-2.svg",
				curp: "",
				curpOK: false,
				ineOK: false,
				messageIne: "",
				firstName :"",
			    lastName :"",
			    motherLastName :"",
				birthDate:"",
				birthPlace:"",
				CURPInfo:"",
				BIRTH_CERTIFICATE_INF:"",
				INE_PASSPORT:"",
				INE_PASSPORT_INF:"",
				profile_picture:"",
				namex:"",
				urlIne: "",
				urlCURP: "",
				url: "",
				tituloUrl: "",
			}
		},
		computed: {
			...mapGetters({
				benefName: "getBeneficiaryName"
			}),
			beneficiaryName: {
				get(){
					return this.benefName;
				},
				set(value){
					this.$store.commit("_setName", value);
				}
			}
		},
		methods: {
			chooseFile(){
				document.getElementById("fileUpload").click();
			},
			chooseFileCurp(){
				document.getElementById("fileUploadCurp").click();
			},
			chooseFileColonia(){
				document.getElementById("fileUploadColonia").click();
			},
			chooseFileCartaAntec(){
				document.getElementById("fileUploadCartaAntec").click();
			},
			chooseFileIdentificacion(){
				document.getElementById("fileUploadIdentificacion").click();
			},
			mouseOverIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
			},
			mouseLeaveIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
			},
			seeBirthPlace(urlSrc, title){
				this.url = urlSrc,
				this.tituloUrl = title;
				this.$refs.confirm.toggleModal();
			},

		}
	}
</script>
<style>


	.profile_picture{
		width: 140px;
		height: 140px;
		overflow: hidden;	
		border-radius:50%;
		border: 4px solid #3a8a65;
	}
	.uploadIcon {
	cursor: pointer;
	background-color: rgb(220, 113, 52);
	padding: 9.4px;
	border-radius: 0px 4px 4px 0px;
	/* margin-top: 12px;
		margin-left: 20px; */
	}

	.curp-upload > input {
		display: none;
	}


	.t1-input-colonia {
		/* max-width: 80%; */
		display: inline;
		transform: translateY(3px);
		margin-bottom: 10px !important; 
	}

	.t1-input-curp {
		display: inline; 
		max-width: 70%; 
		transform: translateY(3px);
	}

	.t1-input-dia,
	.t1-input-mes {
		text-align: center;
		display: inline; 
		width: 8%; 
		margin-right: 15px; 
		transform: translateY(3px);
	}

	.t1-input-ano {
		text-align: center; 
		display: inline; 
		width: 12%; 
		transform: translateY(3px);
	}

	.btn-comprobante-domicilio {
		/* margin-left: 10px; */
		display: inline;
	}

	.btn-acta-nacimiento {
		display: inline-block; 
		margin-left: 10px;
	}

	.btn-upload-curp {
		display: inline; 
		margin-left: 10px;
	}

	.info-icon {
		width: 2rem;
		height: 2rem;
		margin-left: 1rem;
		transition: transform .2s;
	}

	.info-icon:hover {
		transform: scale(1.3);
	}


		.radio-buttons label {
			display: block;
			color: #828282;
			font-size: 1.4rem;
			font-weight: 600;
			text-align: left;
			cursor: pointer;
			padding-left: 10px;
			padding-right: 10px;
		}

		.custom-radio .custom-control-label::before {
			border-radius: 50%;
			width: 15px;
			height: 15px;
			margin-right: 15px;
		}


		.custom-control-input:checked ~ .custom-control-label::before {
			color: #fff;
			border-color: #f78c4f;
			background-color: #f78c4f;
		}

		.custom-control-label::after {
			position: absolute;
			top: .25rem;
			left: -1.5rem;
			display: block;
			width: 15px;
			height: 15px;
			content: "";
			background: no-repeat 50%/50% 50%;
		}


		.t2-table-title-left {
			color: #3a8a65;
			font-size: 18px;
		}

		.t2-table-title-left img {
			width: 20px;
			height: auto;
			margin-top: -.5rem;
			margin-right: 5px;
		}

	@media(max-width: 1199px){
		.t1-input-curp {
			display: block; 
			max-width: 100%; 
			transform: translateY(3px);
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 12%; 
		}


		.t1-input-ano {
			width: 18%; 
		}

		.btn-upload-curp {
			display: block; 
			margin-top: 10px;
			margin-left: 0px;
		}

		.btn-acta-nacimiento {
			display: block; 
			margin-left: 0px;
			margin-top: 10px;
		}
	}

	@media(max-width: 992px){
		.btn-comprobante-domicilio {
			margin-left: 0px;
			display: block;
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 18%; 
		}


		.t1-input-ano {
			width: 28%; 
		}


		.t1-input-colonia {
			max-width: 100%;
			margin-bottom: 10px;
			display: block;
		} 
	}

	@media(max-width: 768px){
		.t1-input-colonia {
			max-width: 100%;
		}
	}

	@media (max-width: 576px) { 

		}
</style>
